import { Field } from '@chipinside/formbuilder'
import { isObject } from 'lodash'

import {
  buildDateField,
  buildDateFormatField,
  buildFileField,
  buildImportTypeField,
  buildInstructionsField,
  buildProtocolField,
  buildSpreadsheetField,
} from '#/store/hooks/useForms/Import/fields'
import { getImportTypeConfig } from '#/store/hooks/useForms/Import/types'

interface IGetImportFormFieldsParams {
  withDate?: boolean
  type: string
  format_file?: string
  fileURL?: string
}

export const getImportFormFields = ({
  fileURL,
  format_file = '.xlsx',
  type,
  withDate,
}: IGetImportFormFieldsParams) => {
  const fields: any[] = []
  const config = getImportTypeConfig(type)

  if (config.spreadsheet) {
    fields.push(buildSpreadsheetField({ spreadsheet: config.spreadsheet }))
    config.spreadsheet.instructions.forEach(instruction => {
      fields.push(
        buildInstructionsField({
          fileURL,
          format_file,
          instructions: config.instructions,
          name: instruction.name,
          spreadsheetType: instruction.spreadsheetType,
        }),
      )
    })
  } else {
    fields.push(
      buildInstructionsField({
        fileURL,
        format_file,
        instructions: config.instructions,
        name: 'instructions',
      }),
    )
  }

  if (config.protocolField) {
    fields.push(buildProtocolField({ protocolField: config.protocolField }))
  }

  if (withDate) {
    fields.push(buildDateField({ dateField: config.dateField }))
  }

  if (config.dateFormat) {
    const defaultValue = isObject(config.dateFormat) ? config.dateFormat.default : undefined
    fields.push(buildDateFormatField({ defaultValue }))
  }

  if (config.importType) {
    fields.push(buildImportTypeField())
  }

  fields.push(buildFileField({ format_file }))

  return {
    fields: fields as Field[],
  }
}
